import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var image = require("../utils/image");
var jobUtils = require("../utils/jobs");
var PDF = require("./PDF");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Job
 * @static
 * @hideconstructor
 */

/**
 * Get a job list depending on the filter provided
 * @method getJobs
 * @name Jobin.Job.getJobs
 * @param {ParseObject} user
 * @param {Integer} limit
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {Array} provinces
 * @param {Array} services
 * @param {Array} levels
 * @param {Array} slots
 * @param {Array} jobState
 * @param {string} id
 * @param {Array} stores
 * @param {Array} orders
 * @param {boolean} creationDate
 * @param {boolean} deliveryDate
 * @param {Array} businesses
 * @param {boolean} countFlag
 * @returns {Array} Jobs object.
 */
export function getJobs(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
  return _getJobs.apply(this, arguments);
}
/**
 * Get job for user params
 * @method getJobsForUser
 * @name Jobin.Job.getJobsForUser
 * @param {string} name
 * @param {string} phone
 * @returns {Array} Jobs ParseObjects.
 */
function _getJobs() {
  _getJobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(user, limit, startDate, endDate, provinces, services, levels, slots, jobStates) {
    var id,
      stores,
      orders,
      creationDate,
      deliveryDate,
      businesses,
      agents,
      countFlag,
      finalQuery,
      results,
      count,
      _yield$finalQuery$wit,
      formattedJobs,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _args.length > 9 && _args[9] !== undefined ? _args[9] : "";
          stores = _args.length > 10 ? _args[10] : undefined;
          orders = _args.length > 11 ? _args[11] : undefined;
          creationDate = _args.length > 12 ? _args[12] : undefined;
          deliveryDate = _args.length > 13 ? _args[13] : undefined;
          businesses = _args.length > 14 ? _args[14] : undefined;
          agents = _args.length > 15 ? _args[15] : undefined;
          countFlag = _args.length > 16 ? _args[16] : undefined;
          _context.next = 10;
          return jobUtils.getFullQuery(user, limit, startDate, endDate, provinces, services, levels, slots, jobStates, id, stores, orders, creationDate, deliveryDate, businesses, agents);
        case 10:
          finalQuery = _context.sent;
          if (id.startsWith("PC-")) {
            finalQuery.select(["Job.Vertical", "Job.Subvertical.nLeadsPerPC", "Job.From", "Verified", "Job.Business", "ID", "Job.Title", "Job.State", "Job.JobType", "Job.Address", "Job.PostalCode", "Job.nJober", "Job.Type", "Job.CreatedBy.Name", "Job.CreatedBy.Phone", "Job.AssignedTo.Lastname", "Job.AssignedTo.Name", "FixedPrice", "Guild.Name"]);
          } else if (id.startsWith("TR-")) {
            finalQuery.select(["Job.Vertical", "Job.Subvertical.nLeadsPerPC", "Job.From", "State", "ID", "DeliveryDate", "Job.Title", "Job.State", "Job.Type", "Job.JobType", "Job.Address", "Job.CreatedBy.Name", "Job.CreatedBy.Phone"]);
          } else {
            finalQuery.select(["Vertical", "Subvertical.nLeadsPerPC", "JobLeadPrice", "Verified", "From", "Business", "Title", "State", "Budget", "Job.State", "TotalSlots", "JobType", "Address", "PostalCode", "Level", "nJober", "Type", "Subvertical.Type", "AssignedTo.Lastname", "AssignedTo.Name", "CreatedBy.Name", "CreatedBy.Phone", "Incidence"]);
          }
          finalQuery.descending("createdAt");
          _context.prev = 13;
          if (!countFlag) {
            _context.next = 22;
            break;
          }
          _context.next = 17;
          return finalQuery.withCount(true).find();
        case 17:
          _yield$finalQuery$wit = _context.sent;
          results = _yield$finalQuery$wit.results;
          count = _yield$finalQuery$wit.count;
          _context.next = 26;
          break;
        case 22:
          _context.next = 24;
          return finalQuery.find();
        case 24:
          results = _context.sent;
          count = undefined;
        case 26:
          formattedJobs = results.map(function (result) {
            var job = result.has("Job") ? result.get("Job") : result;
            var user = job.get("CreatedBy");
            var subvertical = job.get("Subvertical");
            var agent = job.get("AssignedTo");
            var fJob = {
              id: job.id,
              name: user ? user.get("Name") : undefined,
              phone: user ? user.get("Phone") : undefined,
              title: job.get("Title"),
              state: job.get("State"),
              verified: job.get("Verified"),
              jobType: job.get("JobType"),
              level: job.get("Level"),
              type: job.get("Type"),
              incidence: job.get("Incidence"),
              Budget: job.get("Budget"),
              subtype: subvertical ? subvertical.get("Type") : undefined,
              address: job.get("Address"),
              jobLeadPrice: job.get("JobLeadPrice"),
              locality: jobUtils.getProvince(job.get("PostalCode")),
              createdAt: job.get("createdAt"),
              totalSlots: job.get("TotalSlots"),
              takenSlots: job.get("TotalSlots") - job.get("nJober"),
              nJober: job.get("nJober"),
              jobID: result.has("ID") ? result.get("ID") : undefined,
              deliveryDate: result.has("DeliveryDate") ? result.get("DeliveryDate") : undefined,
              transportState: result.get("State"),
              fixedPrice: result.get("FixedPrice"),
              assignedAgentName: agent && agent.has("Lastname") ? agent.get("Name") + " " + agent.get("Lastname") : agent ? agent.get("Name") : undefined,
              priority: job.get("Priority"),
              business: job.get("Business"),
              vertical: job.get("Vertical"),
              subVertical: job.get("Subvertical"),
              guild: result.get("Guild"),
              from: job.get("From")
            };
            return fJob;
          });
          return _context.abrupt("return", {
            status: "ok",
            result: {
              jobs: formattedJobs,
              count: count
            }
          });
        case 30:
          _context.prev = 30;
          _context.t0 = _context["catch"](13);
          console.error(_context.t0);
          return _context.abrupt("return", {
            status: "error",
            result: _context.t0
          });
        case 34:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[13, 30]]);
  }));
  return _getJobs.apply(this, arguments);
}
export function getJobsForUser(_x10, _x11) {
  return _getJobsForUser.apply(this, arguments);
}
/**
 * Get all the job info
 * @method getJobById
 * @name Jobin.Job.getJobById
 * @param {string} jobId
 * @returns {Array} Jobs ParseObjects.
 */
function _getJobsForUser() {
  _getJobsForUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(name, phone) {
    var businessId,
      queryUser,
      usersArray,
      queryJobs,
      results,
      formattedJobs,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          businessId = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
          if (!sessionToken.getToken()) {
            _context2.next = 42;
            break;
          }
          if (!(name && name.length > 0 || phone && phone.length > 0)) {
            _context2.next = 39;
            break;
          }
          queryUser = new Parse.Query(Parse.Object.extend("User"));
          if (name) queryUser.contains("Name", name);
          if (phone) queryUser.contains("Phone", phone);
          queryUser.select(["objectId"]);
          _context2.prev = 7;
          _context2.next = 10;
          return queryUser.first();
        case 10:
          usersArray = _context2.sent;
          if (!usersArray) {
            _context2.next = 30;
            break;
          }
          queryJobs = new Parse.Query(Parse.Object.extend("Jobs"));
          queryJobs.equalTo("CreatedBy", Parse.User.createWithoutData(usersArray.id));
          if (businessId) {
            queryJobs.equalTo("Business", Parse.Object.extend("Business").createWithoutData(businessId));
          }
          queryJobs.select(["Title", "State", "TotalSlots", "JobType", "Business", "Address", "PostalCode", "Level", "nJober", "Type", "Subvertical.Type", "CreatedBy.Name", "CreatedBy.Phone"]);
          _context2.prev = 16;
          _context2.next = 19;
          return queryJobs.find();
        case 19:
          results = _context2.sent;
          formattedJobs = results.map(function (job) {
            var user = job.get("CreatedBy");
            var subvertical = job.get("Subvertical");
            var fJob = {
              id: job.id,
              name: user ? user.get("Name") : undefined,
              phone: user ? user.get("Phone") : undefined,
              title: job.get("Title"),
              state: job.get("State"),
              jobType: job.get("JobType"),
              level: job.get("Level"),
              type: job.get("Type"),
              business: job.get("Business"),
              subtype: subvertical ? subvertical.get("Type") : undefined,
              address: job.get("Address"),
              locality: jobUtils.getProvince(job.get("PostalCode")),
              createdAt: job.get("createdAt"),
              totalSlots: job.get("TotalSlots"),
              takenSlots: job.get("TotalSlots") - job.get("nJober"),
              nJober: job.get("nJober"),
              jobID: undefined,
              deliveryDate: undefined,
              transportState: undefined
            };
            return fJob;
          });
          return _context2.abrupt("return", {
            status: "ok",
            result: {
              jobs: formattedJobs
            }
          });
        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](16);
          console.error(_context2.t0);
          return _context2.abrupt("return", {
            status: "error",
            result: "Fallo al buscar trabajos por usuario"
          });
        case 28:
          _context2.next = 31;
          break;
        case 30:
          return _context2.abrupt("return", {
            status: "ok",
            result: {
              jobs: []
            }
          });
        case 31:
          _context2.next = 37;
          break;
        case 33:
          _context2.prev = 33;
          _context2.t1 = _context2["catch"](7);
          console.error(_context2.t1);
          return _context2.abrupt("return", {
            status: "error",
            result: "Fallo al buscar trabajos por usuario"
          });
        case 37:
          _context2.next = 40;
          break;
        case 39:
          return _context2.abrupt("return", {
            status: "error",
            result: "Es necesario al menos enviar uno de los parámetros"
          });
        case 40:
          _context2.next = 43;
          break;
        case 42:
          return _context2.abrupt("return", {
            status: "error",
            result: "Es necesario sessionToken para realizar la petición"
          });
        case 43:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 33], [16, 24]]);
  }));
  return _getJobsForUser.apply(this, arguments);
}
export function getJobById(_x12) {
  return _getJobById.apply(this, arguments);
}
/**
 * Get all the job info
 * @method getJobsById
 * @name Jobin.Job.getJobsById
 * @param {string[]} jobIds
 * @returns {Parse.Object[]} Jobs ParseObjects.
 */
function _getJobById() {
  _getJobById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(jobId) {
    var currentUser, query, job, jobType, _query, _query2;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context3.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context3.next = 42;
            break;
          }
          query = new Parse.Query("Jobs");
          query.equalTo("objectId", jobId);
          _context3.prev = 6;
          _context3.next = 9;
          return query.first();
        case 9:
          job = _context3.sent;
          jobType = job.get("JobType");
          if (!(jobType === "fixed")) {
            _context3.next = 22;
            break;
          }
          //Search FixedInfo
          _query = new Parse.Query("FixedInfo");
          _query.equalTo("Job", job);
          _context3.t0 = job;
          _context3.next = 17;
          return _query.first();
        case 17:
          _context3.t1 = _context3.sent;
          _context3.t2 = {
            job: _context3.t0,
            fixedInfo: _context3.t1
          };
          return _context3.abrupt("return", {
            status: "ok",
            result: _context3.t2
          });
        case 22:
          if (!(jobType === "transport")) {
            _context3.next = 33;
            break;
          }
          //Search Transportation
          _query2 = new Parse.Query("Transportation");
          _query2.equalTo("Job", job);
          _context3.t3 = job;
          _context3.next = 28;
          return _query2.first();
        case 28:
          _context3.t4 = _context3.sent;
          _context3.t5 = {
            job: _context3.t3,
            transportation: _context3.t4
          };
          return _context3.abrupt("return", {
            status: "ok",
            result: _context3.t5
          });
        case 33:
          return _context3.abrupt("return", {
            status: "ok",
            result: {
              job: job
            }
          });
        case 34:
          _context3.next = 40;
          break;
        case 36:
          _context3.prev = 36;
          _context3.t6 = _context3["catch"](6);
          console.error(_context3.t6);
          return _context3.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de obtener la información del trabajo."
          });
        case 40:
          _context3.next = 43;
          break;
        case 42:
          return _context3.abrupt("return", {
            status: "error",
            result: "No tienes permisos para hacer esta petición."
          });
        case 43:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[6, 36]]);
  }));
  return _getJobById.apply(this, arguments);
}
export function getJobsById(_x13) {
  return _getJobsById.apply(this, arguments);
}
/**
 * Get all the current Client open Jobs
 * @method getOpenJobs
 * @name Jobin.Job.getOpenJobs
 * @returns {Array} Jobs ParseObjects.
 */
function _getJobsById() {
  _getJobsById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(jobIds) {
    var currentUser, jobs, fixedJobs, transportJobs, transportations, fixedInfos;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context4.sent;
          if (!(!currentUser && !sessionToken.getToken())) {
            _context4.next = 7;
            break;
          }
          return _context4.abrupt("return", {
            status: "error",
            result: "No tienes permisos para hacer esta petición."
          });
        case 7:
          _context4.prev = 7;
          _context4.next = 10;
          return new Parse.Query("Jobs").containedIn("objectId", jobIds).find();
        case 10:
          jobs = _context4.sent;
          fixedJobs = jobs.filter(function (job) {
            return job.get("JobType") === "fixed";
          });
          transportJobs = jobs.filter(function (job) {
            return job.get("JobType") === "transport";
          });
          if (!(fixedJobs.length > 0)) {
            _context4.next = 17;
            break;
          }
          _context4.next = 16;
          return new Parse.Query("FixedInfo").containedIn("Job", jobs).find();
        case 16:
          fixedInfos = _context4.sent;
        case 17:
          if (!(transportJobs.length > 0)) {
            _context4.next = 21;
            break;
          }
          _context4.next = 20;
          return new Parse.Query("Transportation").containedIn("Job", jobs).find();
        case 20:
          transportations = _context4.sent;
        case 21:
          return _context4.abrupt("return", {
            status: "ok",
            result: {
              jobs: jobs,
              fixedInfos: fixedInfos,
              transportations: transportations
            }
          });
        case 24:
          _context4.prev = 24;
          _context4.t0 = _context4["catch"](7);
          console.error(_context4.t0);
          return _context4.abrupt("return", {
            status: "error",
            result: "Hubo un error al tratar de obtener la información del trabajo."
          });
        case 28:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[7, 24]]);
  }));
  return _getJobsById.apply(this, arguments);
}
export function getOpenJobs() {
  return _getOpenJobs.apply(this, arguments);
}
/**
 * Returns all jobs contained in a jober payoff
 * @method getJoberPayoffJobs
 * @name Jobin.Job.getJoberPayoffJobs
 * @param {string} paymentId Jober payoff payment id
 * @returns {jobs: Parse.Object[], fixedInfos: Parse.Object[] ,transportations: Parse.Object[]}
 */
function _getOpenJobs() {
  _getOpenJobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var currentUser, Jobs, query;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context5.sent;
          Jobs = Parse.Object.extend("Jobs");
          query = new Parse.Query(Jobs);
          query.equalTo("CreatedBy", currentUser);
          query.containedIn("State", ["draft", "abierto", "full", "pending"]);
          query.containedIn("JobType", ["fixed", "lead"]);
          query.descending("createdAt");
          _context5.prev = 9;
          _context5.next = 12;
          return query.find();
        case 12:
          _context5.t0 = _context5.sent;
          return _context5.abrupt("return", {
            status: "ok",
            result: _context5.t0
          });
        case 16:
          _context5.prev = 16;
          _context5.t1 = _context5["catch"](9);
          console.error(_context5.t1);
          return _context5.abrupt("return", {
            status: "error",
            result: "Hubo un problema y no hemos podido obtener tus solicitudes pendientes. Inténtalo de nuevo más tarde."
          });
        case 20:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[9, 16]]);
  }));
  return _getOpenJobs.apply(this, arguments);
}
export function getJoberPayoffJobs(_x14) {
  return _getJoberPayoffJobs.apply(this, arguments);
}
/**
 * Download the Jobers that bought the job
 * @method getJobersForJob
 * @name Jobin.Job.getJobersForJob
 * @param {ParseObject} job
 * @returns {Array} User ParseObject.
 */
function _getJoberPayoffJobs() {
  _getJoberPayoffJobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(paymentId) {
    var joberPayoff, fixedInfos, transportations, fixedJobs, transportJobs;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          joberPayoff = Parse.Object.extend("Payments").createWithoutData(paymentId);
          _context6.next = 4;
          return new Parse.Query("FixedInfo").equalTo("JoberPayoff", joberPayoff).include("Job").find();
        case 4:
          fixedInfos = _context6.sent;
          _context6.next = 7;
          return new Parse.Query("Transportation").equalTo("JoberPayoff", joberPayoff).include("Job").find();
        case 7:
          transportations = _context6.sent;
          fixedJobs = fixedInfos.map(function (fixedInfo) {
            return fixedInfo.get("Job");
          });
          transportJobs = transportations.map(function (transport) {
            return transport.get("Job");
          });
          return _context6.abrupt("return", {
            status: "ok",
            result: {
              transportations: transportations,
              fixedInfos: fixedInfos,
              jobs: fixedJobs.concat(transportJobs)
            }
          });
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          console.error(_context6.t0);
          return _context6.abrupt("return", {
            status: "error",
            result: "Error al cargar trabajos relacionados"
          });
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  }));
  return _getJoberPayoffJobs.apply(this, arguments);
}
export function getJobersForJob(_x15) {
  return _getJobersForJob.apply(this, arguments);
}
/**
 * Get a user friendly state string
 * @method getPredefinedJobersForJob
 * @name Jobin.Job.getPredefinedJobersForJob
 * @param {ParseObject} job
 * @returns {Array} Array of objectId of the jobers.
 */
function _getJobersForJob() {
  _getJobersForJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(job) {
    var Notifications, queryNotifi, notifiArray, tempArray, jobState, i, notification, _i, _notification, jober, j, tempJober;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          Notifications = Parse.Object.extend("Notifications");
          queryNotifi = new Parse.Query(Notifications);
          queryNotifi.equalTo("Jobs", job);
          queryNotifi.include(["FromUser"]);
          queryNotifi.descending("createdAt");
          _context7.prev = 5;
          _context7.next = 8;
          return queryNotifi.find();
        case 8:
          notifiArray = _context7.sent;
          tempArray = [];
          jobState = job.get("State");
          for (i = 0; i < notifiArray.length; i++) {
            notification = notifiArray[i];
            if (notification.get("Type") === "aceptoT") {
              tempArray.push(notification.get("FromUser"));
            }
          }
          if (!(jobState === "review" || jobState === "finalizado")) {
            _context7.next = 30;
            break;
          }
          _i = 0;
        case 14:
          if (!(_i < notifiArray.length)) {
            _context7.next = 30;
            break;
          }
          _notification = notifiArray[_i];
          if (!(_notification.get("Type") === jobState)) {
            _context7.next = 27;
            break;
          }
          jober = _notification.get("ToUser");
          j = 0;
        case 19:
          if (!(j < tempArray.length)) {
            _context7.next = 27;
            break;
          }
          tempJober = tempArray[j];
          if (!(tempJober.id === jober.id)) {
            _context7.next = 24;
            break;
          }
          tempJober.set("Action", jobState);
          return _context7.abrupt("break", 27);
        case 24:
          j++;
          _context7.next = 19;
          break;
        case 27:
          _i++;
          _context7.next = 14;
          break;
        case 30:
          return _context7.abrupt("return", {
            status: "ok",
            result: tempArray
          });
        case 33:
          _context7.prev = 33;
          _context7.t0 = _context7["catch"](5);
          console.error(_context7.t0);
          return _context7.abrupt("return", {
            status: "error",
            result: "Debido a un error no ha sido posible descargar los Jobers inscritos en tu solicitud."
          });
        case 37:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[5, 33]]);
  }));
  return _getJobersForJob.apply(this, arguments);
}
export function getPredefinedJobersForJob(_x16) {
  return _getPredefinedJobersForJob.apply(this, arguments);
}
/**
 * Get all the current Client closed Jobs
 * @method getCloseJobs
 * @name Jobin.Job.getCloseJobs
 * @returns {Array} Jobs ParseObjects.
 */
function _getPredefinedJobersForJob() {
  _getPredefinedJobersForJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(job) {
    var subvertical, deliveryJobers, postalCode, jobersArray;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          subvertical = job.get("Subvertical");
          _context8.prev = 1;
          _context8.next = 4;
          return subvertical.fetch();
        case 4:
          deliveryJobers = subvertical.get("DeliveryJobers");
          if (!(job.get("JobType") === "fixed" && deliveryJobers && deliveryJobers.fixedJobers)) {
            _context8.next = 15;
            break;
          }
          postalCode = job.get("PostalCode").substring(0, 2);
          jobersArray = deliveryJobers.fixedJobers[postalCode];
          if (!jobersArray) {
            _context8.next = 12;
            break;
          }
          return _context8.abrupt("return", {
            status: "ok",
            result: jobersArray
          });
        case 12:
          return _context8.abrupt("return", {
            status: "ok",
            result: null
          });
        case 13:
          _context8.next = 20;
          break;
        case 15:
          if (!(job.get("JobType") === "transport" && deliveryJobers && deliveryJobers.transportJobers)) {
            _context8.next = 19;
            break;
          }
          return _context8.abrupt("return", {
            status: "ok",
            result: deliveryJobers.transportJobers
          });
        case 19:
          return _context8.abrupt("return", {
            status: "ok",
            result: null
          });
        case 20:
          _context8.next = 26;
          break;
        case 22:
          _context8.prev = 22;
          _context8.t0 = _context8["catch"](1);
          console.error(_context8.t0);
          return _context8.abrupt("return", {
            status: "error",
            result: "Hubo un problema al tratar de obtener los datos de la subvertical"
          });
        case 26:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[1, 22]]);
  }));
  return _getPredefinedJobersForJob.apply(this, arguments);
}
export function getCloseJobs() {
  return _getCloseJobs.apply(this, arguments);
}
/**
 * Get the jobs related with other job (Guarantee or return)
 * @method getRelatedJob
 * @name Jobin.Job.getRelatedJob
 * @param {ParseObject} object FixedInfo or Transportation object
 * @returns {ParseObject} Job related to de object.
 */
function _getCloseJobs() {
  _getCloseJobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var currentUser, Review, reviewQuery;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context9.sent;
          //Get the reviews
          Review = Parse.Object.extend("Review");
          reviewQuery = new Parse.Query(Review);
          reviewQuery.equalTo("User", currentUser);
          reviewQuery.include(["Job.Title", "Job.Type", "Jober.Name", "Jober.Thumbnail"]);
          reviewQuery.descending("createdAt");
          _context9.prev = 8;
          _context9.next = 11;
          return reviewQuery.find();
        case 11:
          _context9.t0 = _context9.sent;
          return _context9.abrupt("return", {
            status: "ok",
            result: _context9.t0
          });
        case 15:
          _context9.prev = 15;
          _context9.t1 = _context9["catch"](8);
          console.error(_context9.t1);
          return _context9.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar tus solicitudes finalizadas. Prueba de nuevo más tarde."
          });
        case 19:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[8, 15]]);
  }));
  return _getCloseJobs.apply(this, arguments);
}
export function getRelatedJob(_x17) {
  return _getRelatedJob.apply(this, arguments);
}
/**
 * Delete or delete a Job from server
 * @method cancelJob
 * @name Jobin.Job.cancelJob
 * @param {ParseObject} job
 * @param {string} action //eliminado o falso
 * @param {Object} summary
 * @param {string} iban
 * @returns {boolean} Success.
 */
function _getRelatedJob() {
  _getRelatedJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(object) {
    var id, FixedInfo, query, relatedFixedInfo, Transportation, _query3, relatedTransportInfo;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          id = object.get("ID");
          if (!id.startsWith("PC")) {
            _context10.next = 19;
            break;
          }
          FixedInfo = Parse.Object.extend("FixedInfo");
          query = new Parse.Query(FixedInfo);
          query.equalTo("objectId", object.get("RelatedTo").id);
          query.include("Job");
          _context10.prev = 6;
          _context10.next = 9;
          return query.first();
        case 9:
          relatedFixedInfo = _context10.sent;
          return _context10.abrupt("return", {
            status: "ok",
            result: relatedFixedInfo.get("Job")
          });
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](6);
          console.error(_context10.t0);
          return _context10.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar tus solicitudes finalizadas. Prueba de nuevo más tarde."
          });
        case 17:
          _context10.next = 38;
          break;
        case 19:
          if (!id.startsWith("TR")) {
            _context10.next = 37;
            break;
          }
          Transportation = Parse.Object.extend("Transportation");
          _query3 = new Parse.Query(Transportation);
          _query3.equalTo("objectId", object.get("RelatedTo").id);
          _query3.include("Job");
          _context10.prev = 24;
          _context10.next = 27;
          return _query3.first();
        case 27:
          relatedTransportInfo = _context10.sent;
          return _context10.abrupt("return", {
            status: "ok",
            result: relatedTransportInfo.get("Job")
          });
        case 31:
          _context10.prev = 31;
          _context10.t1 = _context10["catch"](24);
          console.error(_context10.t1);
          return _context10.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar tus solicitudes finalizadas. Prueba de nuevo más tarde."
          });
        case 35:
          _context10.next = 38;
          break;
        case 37:
          return _context10.abrupt("return", {
            status: "error",
            result: "No existe un trabajo relacionado con este servicio."
          });
        case 38:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[6, 13], [24, 31]]);
  }));
  return _getRelatedJob.apply(this, arguments);
}
export function cancelJob(_x18, _x19, _x20, _x21) {
  return _cancelJob.apply(this, arguments);
}
/**
 * Finish a job and link to a Jober
 * @method finishJob
 * @name Jobin.Job.finishJob
 * @param {ParseObject} job
 * @param {ParseObject} jober //optional
 * @param {ParseObject} fixedInfo //optional
 * @returns {boolean} Success.
 */
function _cancelJob() {
  _cancelJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(job, action, summary, iban) {
    var jobType, result, _result, _result2, _result3;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          jobType = job.get("JobType");
          if (!(jobType === "lead" && action == "eliminado")) {
            _context11.next = 16;
            break;
          }
          _context11.prev = 2;
          _context11.next = 5;
          return Parse.Cloud.run("modifyJobType", {
            modificationType: action,
            idJob: job.id,
            sessionToken: sessionToken.getToken()
          });
        case 5:
          result = _context11.sent;
          if (!result) {
            _context11.next = 8;
            break;
          }
          return _context11.abrupt("return", {
            status: "ok",
            result: true
          });
        case 8:
          _context11.next = 14;
          break;
        case 10:
          _context11.prev = 10;
          _context11.t0 = _context11["catch"](2);
          console.error(_context11.t0);
          return _context11.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido eliminar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 14:
          _context11.next = 64;
          break;
        case 16:
          if (!(jobType === "lead" && action == "falso")) {
            _context11.next = 31;
            break;
          }
          _context11.prev = 17;
          _context11.next = 20;
          return Parse.Cloud.run("markJobsAsFalse", {
            jobId: job.id,
            sessionToken: sessionToken.getToken()
          });
        case 20:
          _result = _context11.sent;
          if (!_result) {
            _context11.next = 23;
            break;
          }
          return _context11.abrupt("return", {
            status: "ok",
            result: true
          });
        case 23:
          _context11.next = 29;
          break;
        case 25:
          _context11.prev = 25;
          _context11.t1 = _context11["catch"](17);
          console.error(_context11.t1);
          return _context11.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido eliminar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 29:
          _context11.next = 64;
          break;
        case 31:
          if (!(jobType === "transport")) {
            _context11.next = 47;
            break;
          }
          _context11.prev = 32;
          _context11.next = 35;
          return Parse.Cloud.run("cancelOneTransportation", {
            jobId: job.id,
            newState: action,
            sessionToken: sessionToken.getToken()
          });
        case 35:
          _result2 = _context11.sent;
          if (!_result2) {
            _context11.next = 38;
            break;
          }
          return _context11.abrupt("return", {
            status: "ok",
            result: true
          });
        case 38:
          return _context11.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido cancelar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 41:
          _context11.prev = 41;
          _context11.t2 = _context11["catch"](32);
          console.error(_context11.t2);
          return _context11.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido eliminar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 45:
          _context11.next = 64;
          break;
        case 47:
          if (!(jobType === "fixed")) {
            _context11.next = 63;
            break;
          }
          _context11.prev = 48;
          _context11.next = 51;
          return Parse.Cloud.run("cancelFixedJob", {
            jobId: job.id,
            summary: summary,
            newState: action,
            sessionToken: sessionToken.getToken(),
            iban: iban
          });
        case 51:
          _result3 = _context11.sent;
          if (!_result3) {
            _context11.next = 54;
            break;
          }
          return _context11.abrupt("return", {
            status: "ok",
            result: true
          });
        case 54:
          return _context11.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido cancelar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 57:
          _context11.prev = 57;
          _context11.t3 = _context11["catch"](48);
          console.error(_context11.t3);
          return _context11.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido eliminar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 61:
          _context11.next = 64;
          break;
        case 63:
          return _context11.abrupt("return", {
            status: "error",
            result: "No es posible eliminar este tipo de trabajos"
          });
        case 64:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[2, 10], [17, 25], [32, 41], [48, 57]]);
  }));
  return _cancelJob.apply(this, arguments);
}
export function finishJob(_x22, _x23) {
  return _finishJob.apply(this, arguments);
}
function _finishJob() {
  _finishJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(job, jober) {
    var jobType, createdBy, result, _result4, _result5;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          jobType = job.get("JobType");
          if (!(jobType === "lead" || jobType === "bid")) {
            _context12.next = 18;
            break;
          }
          _context12.prev = 2;
          createdBy = job.get("CreatedBy");
          _context12.next = 6;
          return Parse.Cloud.run("finishJob", {
            jobId: job.id,
            joberId: jober.id,
            userId: createdBy.id,
            sessionToken: sessionToken.getToken()
          });
        case 6:
          result = _context12.sent;
          if (!result) {
            _context12.next = 9;
            break;
          }
          return _context12.abrupt("return", {
            status: "ok",
            result: true
          });
        case 9:
          return _context12.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido finalizar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 12:
          _context12.prev = 12;
          _context12.t0 = _context12["catch"](2);
          console.error(_context12.t0);
          return _context12.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido finalizar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 16:
          _context12.next = 51;
          break;
        case 18:
          if (!(jobType === "transport")) {
            _context12.next = 34;
            break;
          }
          _context12.prev = 19;
          _context12.next = 22;
          return Parse.Cloud.run("finishTransportation", {
            jobId: job.id,
            sessionToken: sessionToken.getToken()
          });
        case 22:
          _result4 = _context12.sent;
          if (!_result4) {
            _context12.next = 25;
            break;
          }
          return _context12.abrupt("return", {
            status: "ok",
            result: true
          });
        case 25:
          return _context12.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido finalizar el transporte. Inténtalo de nuevo más tarde."
          });
        case 28:
          _context12.prev = 28;
          _context12.t1 = _context12["catch"](19);
          console.error(_context12.t1);
          return _context12.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido finalizar el transporte. Inténtalo de nuevo más tarde."
          });
        case 32:
          _context12.next = 51;
          break;
        case 34:
          if (!(jobType === "fixed")) {
            _context12.next = 50;
            break;
          }
          _context12.prev = 35;
          _context12.next = 38;
          return Parse.Cloud.run("saveSignatureForFixedJob", {
            jobId: job.id,
            joberId: jober.id,
            sessionToken: sessionToken.getToken()
          });
        case 38:
          _result5 = _context12.sent;
          if (!_result5) {
            _context12.next = 41;
            break;
          }
          return _context12.abrupt("return", {
            status: "ok",
            result: true
          });
        case 41:
          return _context12.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido finalizar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 44:
          _context12.prev = 44;
          _context12.t2 = _context12["catch"](35);
          console.error(_context12.t2);
          return _context12.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido finalizar tu solicitud. Inténtalo de nuevo más tarde."
          });
        case 48:
          _context12.next = 51;
          break;
        case 50:
          return _context12.abrupt("return", {
            status: "error",
            result: "Este tipo de trabajos no pueden ser finalizados."
          });
        case 51:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[2, 12], [19, 28], [35, 44]]);
  }));
  return _finishJob.apply(this, arguments);
}
export function reopenJob(_x24) {
  return _reopenJob.apply(this, arguments);
}
/**
 * Finish a job and link to a Jober
 * @method draftToLead
 * @name Jobin.Job.draftToLead
 * @param {ParseObject} job
 * @returns {boolean} Success.
 */
function _reopenJob() {
  _reopenJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(job) {
    var jobType, result;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          jobType = job.get("JobType");
          _context13.prev = 1;
          if (!(jobType == "lead")) {
            _context13.next = 8;
            break;
          }
          _context13.next = 5;
          return Parse.Cloud.run("reopenJob", {
            jobId: job.id,
            sessionToken: sessionToken.getToken()
          });
        case 5:
          result = _context13.sent;
          _context13.next = 18;
          break;
        case 8:
          if (!(jobType == "transport")) {
            _context13.next = 14;
            break;
          }
          _context13.next = 11;
          return Parse.Cloud.run("returnTransportationToStore", {
            jobIds: [job.id],
            sessionToken: sessionToken.getToken()
          });
        case 11:
          result = _context13.sent;
          _context13.next = 18;
          break;
        case 14:
          if (!(jobType == "fixed")) {
            _context13.next = 18;
            break;
          }
          _context13.next = 17;
          return Parse.Cloud.run("reopenFixedJob", {
            jobId: job.id,
            sessionToken: sessionToken.getToken()
          });
        case 17:
          result = _context13.sent;
        case 18:
          return _context13.abrupt("return", {
            status: "ok",
            result: result
          });
        case 21:
          _context13.prev = 21;
          _context13.t0 = _context13["catch"](1);
          console.error(_context13.t0);
          return _context13.abrupt("return", {
            status: "error",
            result: "No se ha podido reabrir el trabajo"
          });
        case 25:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[1, 21]]);
  }));
  return _reopenJob.apply(this, arguments);
}
export function draftToLead(_x25) {
  return _draftToLead.apply(this, arguments);
}
/**
 * Apply guarantee to a fixed job
 * @method applyGuarantee
 * @name Jobin.Job.applyGuarantee
 * @param {ParseObject} job
 * @param {string} description
 * @returns {string} New job id.
 */
function _draftToLead() {
  _draftToLead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return Parse.Cloud.run("transformFixedDraftToLead", {
            jobId: job.id
          });
        case 3:
          result = _context14.sent;
          if (!result) {
            _context14.next = 6;
            break;
          }
          return _context14.abrupt("return", {
            status: "ok",
            result: {
              job: result
            }
          });
        case 6:
          return _context14.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido transformar este trabajo a lead. Inténtalo de nuevo más tarde."
          });
        case 9:
          _context14.prev = 9;
          _context14.t0 = _context14["catch"](0);
          console.error(_context14.t0);
          return _context14.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha podido transformar este trabajo a lead. Inténtalo de nuevo más tarde."
          });
        case 13:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 9]]);
  }));
  return _draftToLead.apply(this, arguments);
}
export function applyGuarantee(_x26, _x27) {
  return _applyGuarantee.apply(this, arguments);
}
/**
 * Change or return a product from a transportation
 * @method changeTransportProduct
 * @name Jobin.Job.changeTransportProduct
 * @param {ParseObject} job
 * @param {string} issue
 * @returns {string} New job id.
 */
function _applyGuarantee() {
  _applyGuarantee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(job, description) {
    var result, fixedInfo;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return Parse.Cloud.run("applyGuarantee", {
            jobId: job.id,
            description: description,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context15.sent;
          if (!result) {
            _context15.next = 12;
            break;
          }
          _context15.next = 7;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(result.fixedObjectId);
        case 7:
          fixedInfo = _context15.sent;
          _context15.next = 10;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: "gen",
            jober: "gen"
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical"), fixedInfo.get("RelatedTo"));
        case 10:
          fixedInfo = _context15.sent;
          return _context15.abrupt("return", {
            status: "ok",
            result: result.job
          });
        case 12:
          return _context15.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha cargado el servicio correctamente."
          });
        case 15:
          _context15.prev = 15;
          _context15.t0 = _context15["catch"](0);
          console.error(_context15.t0);
          return _context15.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha cargado el servicio correctamente."
          });
        case 19:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 15]]);
  }));
  return _applyGuarantee.apply(this, arguments);
}
export function changeTransportProduct(_x28, _x29) {
  return _changeTransportProduct.apply(this, arguments);
}
/**
 * Get the price of a job
 * @method getPrice
 * @name Jobin.Job.getPrice
 * @param {ParseObject} job
 * @param {int} [weight] //optional
 * @returns {int} Price.
 */
function _changeTransportProduct() {
  _changeTransportProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(job, issue) {
    var result;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return Parse.Cloud.run("reUploadTransportation", {
            oldJobId: job.id,
            issue: issue,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context16.sent;
          if (!result) {
            _context16.next = 6;
            break;
          }
          return _context16.abrupt("return", {
            status: "ok",
            result: result.job
          });
        case 6:
          return _context16.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha cargado el servicio correctamente."
          });
        case 9:
          _context16.prev = 9;
          _context16.t0 = _context16["catch"](0);
          console.error(_context16.t0);
          return _context16.abrupt("return", {
            status: "error",
            result: "Parece que hubo un error y no se ha cargado el servicio correctamente."
          });
        case 13:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 9]]);
  }));
  return _changeTransportProduct.apply(this, arguments);
}
export function getPrice(_x30, _x31) {
  return _getPrice.apply(this, arguments);
}
/**
 * Send a Review to a Jober about a Job
 * @method sendReviewForJob
 * @name Jobin.Job.sendReviewForJob
 * @param {number} points
 * @param {string} comment
 * @param {ParseObject} jober
 * @param {ParseObject} job
 * @returns {boolean} Success.
 */
function _getPrice() {
  _getPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(job, weight) {
    var jobType, result, location, _result6, subvertical, postalCode, fixedPrice;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          jobType = job.get("JobType");
          if (!(jobType === "bid" || jobType === "lead")) {
            _context17.next = 19;
            break;
          }
          _context17.prev = 2;
          _context17.next = 5;
          return Parse.Cloud.run("calculateNLeadsForJob", {
            jobId: job.id
          });
        case 5:
          result = _context17.sent;
          if (!result) {
            _context17.next = 10;
            break;
          }
          return _context17.abrupt("return", {
            status: "ok",
            result: result
          });
        case 10:
          return _context17.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar calcular el precio del trabajo"
          });
        case 11:
          _context17.next = 17;
          break;
        case 13:
          _context17.prev = 13;
          _context17.t0 = _context17["catch"](2);
          console.error(_context17.t0);
          return _context17.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar calcular el precio del trabajo"
          });
        case 17:
          _context17.next = 63;
          break;
        case 19:
          if (!(jobType === "transport")) {
            _context17.next = 43;
            break;
          }
          if (!weight) {
            _context17.next = 40;
            break;
          }
          _context17.prev = 21;
          location = job.get("Location");
          _context17.next = 25;
          return Parse.Cloud.run("calculateInstantJobPrice", {
            latitud: location.latitude,
            longitud: location.longitude,
            subCategoryId: job.get("Subvertical").id,
            weight: weight
          });
        case 25:
          _result6 = _context17.sent;
          if (!_result6) {
            _context17.next = 30;
            break;
          }
          return _context17.abrupt("return", {
            status: "ok",
            result: _result6
          });
        case 30:
          return _context17.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar calcular el precio del trabajo"
          });
        case 31:
          _context17.next = 38;
          break;
        case 33:
          _context17.prev = 33;
          _context17.t1 = _context17["catch"](21);
          if (!(_context17.t1.message.code === "WeightLimit" || _context17.t1.message.code === "DistanceLimit")) {
            _context17.next = 37;
            break;
          }
          return _context17.abrupt("return", {
            status: "error",
            result: _context17.t1.message.message
          });
        case 37:
          return _context17.abrupt("return", {
            status: "error",
            result: "Hubo un error al intentar calcular el precio del trabajo"
          });
        case 38:
          _context17.next = 41;
          break;
        case 40:
          return _context17.abrupt("return", {
            status: "error",
            result: "Para calcular el nuevo precio de transporte es necesario pasar el nuevo peso como parámetro"
          });
        case 41:
          _context17.next = 63;
          break;
        case 43:
          if (!(jobType === "fixed")) {
            _context17.next = 62;
            break;
          }
          subvertical = job.get("Subvertical");
          postalCode = job.get("PostalCode").substring(0, 2);
          fixedPrice = subvertical.get("Price").fixed;
          if (!fixedPrice) {
            _context17.next = 59;
            break;
          }
          if (!fixedPrice[postalCode]) {
            _context17.next = 52;
            break;
          }
          return _context17.abrupt("return", {
            status: "ok",
            result: fixedPrice[postalCode].user
          });
        case 52:
          if (!fixedPrice.default) {
            _context17.next = 56;
            break;
          }
          return _context17.abrupt("return", {
            status: "ok",
            result: fixedPrice.default.user
          });
        case 56:
          return _context17.abrupt("return", {
            status: "error",
            result: "Este trabajo no tiene un precio cerrado."
          });
        case 57:
          _context17.next = 60;
          break;
        case 59:
          return _context17.abrupt("return", {
            status: "error",
            result: "Este trabajo no tiene un precio cerrado."
          });
        case 60:
          _context17.next = 63;
          break;
        case 62:
          return _context17.abrupt("return", {
            status: "error",
            result: "No es posible obtener el precio de este tipo de trabajos"
          });
        case 63:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[2, 13], [21, 33]]);
  }));
  return _getPrice.apply(this, arguments);
}
export function sendReviewForJob(_x32, _x33, _x34, _x35) {
  return _sendReviewForJob.apply(this, arguments);
}
/**
 * Get the payments summary of a job
 * @method getPaymentsSummary
 * @name Jobin.Job.getPaymentsSummary
 * @param {ParseObject} job
 * @returns {Object} Payments summary.
 */
function _sendReviewForJob() {
  _sendReviewForJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(points, comment, jober, job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return Parse.Cloud.run("setReview", {
            joberId: jober.id,
            jobId: job.id,
            text: comment,
            stars: points,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context18.sent;
          if (!result) {
            _context18.next = 6;
            break;
          }
          return _context18.abrupt("return", {
            status: "ok",
            result: true
          });
        case 6:
          return _context18.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de enviar tu valoración. Inténtalo de nuevo más tarde."
          });
        case 9:
          _context18.prev = 9;
          _context18.t0 = _context18["catch"](0);
          console.error(_context18.t0);
          return _context18.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de enviar tu valoración. Inténtalo de nuevo más tarde."
          });
        case 13:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 9]]);
  }));
  return _sendReviewForJob.apply(this, arguments);
}
export function getPaymentsSummary(_x36) {
  return _getPaymentsSummary.apply(this, arguments);
}
/**
 * Get the payments summary of a job for a cancelation (with no measures)
 * @method getPaymentsSummaryForCancelation
 * @name Jobin.Job.getPaymentsSummaryForCancelation
 * @param {ParseObject} job
 * @returns {Array} Payments summary.
 */
function _getPaymentsSummary() {
  _getPaymentsSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          _context19.next = 3;
          return Parse.Cloud.run("getJobPaymentSummary", {
            jobId: job.id
          });
        case 3:
          result = _context19.sent;
          if (!result) {
            _context19.next = 6;
            break;
          }
          return _context19.abrupt("return", {
            status: "ok",
            result: result
          });
        case 6:
          return _context19.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de obtener el resumen de pagos de este trabajo."
          });
        case 9:
          _context19.prev = 9;
          _context19.t0 = _context19["catch"](0);
          console.error(_context19.t0);
          return _context19.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de obtener el resumen de pagos de este trabajo."
          });
        case 13:
        case "end":
          return _context19.stop();
      }
    }, _callee19, null, [[0, 9]]);
  }));
  return _getPaymentsSummary.apply(this, arguments);
}
export function getPaymentsSummaryForCancelation(_x37) {
  return _getPaymentsSummaryForCancelation.apply(this, arguments);
}
/**
 * Get all the payments made for this job
 * @method getPayments
 * @name Jobin.Job.getPayments
 * @param {ParseObject} job
 * @returns {Array} ParseObject Payments.
 */
function _getPaymentsSummaryForCancelation() {
  _getPaymentsSummaryForCancelation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return Parse.Cloud.run("getCancelPaymentSummary", {
            jobId: job.id
          });
        case 3:
          result = _context20.sent;
          if (!result) {
            _context20.next = 6;
            break;
          }
          return _context20.abrupt("return", {
            status: "ok",
            result: result
          });
        case 6:
          return _context20.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de obtener el resumen de pagos de este trabajo."
          });
        case 9:
          _context20.prev = 9;
          _context20.t0 = _context20["catch"](0);
          console.error(_context20.t0);
          return _context20.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de obtener el resumen de pagos de este trabajo."
          });
        case 13:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 9]]);
  }));
  return _getPaymentsSummaryForCancelation.apply(this, arguments);
}
export function getPayments(_x38) {
  return _getPayments.apply(this, arguments);
}
/**
 * Get a user friendly state string
 * @method formatState
 * @name Jobin.Job.formatState
 * @param {ParseObject} job
 * @returns {string} state.
 */
function _getPayments() {
  _getPayments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(job) {
    var Payments, query;
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          Payments = Parse.Object.extend("Payments");
          query = new Parse.Query(Payments);
          query.equalTo("Job", job);
          query.descending("createdAt");
          _context21.prev = 4;
          _context21.next = 7;
          return query.find();
        case 7:
          _context21.t0 = _context21.sent;
          return _context21.abrupt("return", {
            status: "ok",
            result: _context21.t0
          });
        case 11:
          _context21.prev = 11;
          _context21.t1 = _context21["catch"](4);
          console.error(_context21.t1);
          return _context21.abrupt("return", {
            status: "error",
            result: "Hubo un problema al tratar de descargar los pagos de este trabajo."
          });
        case 15:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[4, 11]]);
  }));
  return _getPayments.apply(this, arguments);
}
export function formatState(job) {
  var status = job.get("State");
  var jobType = job.get("JobType");
  if (jobType === "fixed") {
    switch (status) {
      case "draft":
        return "Borrador";
      case "pending":
        return "Pendiente de cita";
      case "abierto":
        return "Pendiente de Jober";
      case "full":
        return "En proceso";
      case "signaturePending":
        return "Pendiente de firma";
      case "finalizado":
        return "Firmado";
      case "review":
        return "Servicio valorado";
      case "eliminado":
        return "Servicio eliminado";
      case "falso":
        return "Servicio falso";
    }
  } else if (jobType === "transport") {
    switch (status) {
      case "draft":
        return "Borrador";
      case "pending":
        return "Pendiente de fecha de entrega";
      case "abierto":
        return "Pendiente de Jober";
      case "full":
        return "En reparto";
      case "signaturePending":
        return "Pendiente de firma";
      case "finalizado":
        return "Firmado";
      case "review":
        return "Servicio valorado";
      case "eliminado":
        return "Servicio eliminado";
      case "falso":
        return "Servicio falso";
    }
  } else if (jobType === "lead") {
    switch (status) {
      case "abierto":
        return "Servicio abierto";
      case "full":
        return "Servicio lleno";
      case "finalizado":
        return "Servicio finalizado";
      case "review":
        return "Servicio valorado";
      case "eliminado":
        return "Servicio eliminado";
      case "falso":
        return "Servicio falso";
      case "noJobers":
        return "No hay Jobers disponibles";
      case "standby":
        return "En espera";
      case "frozen":
        return "Servicio congelado";
    }
  }
}
/**
 * Get a user friendly state string
 * @method formatSortState
 * @name Jobin.Job.formatSortState
 * @param {string} jobType
 * @param {string} state
 * @returns {string} state.
 */

export function formatSortState(jobType, state) {
  if (jobType === "fixed") {
    switch (state) {
      case "draft":
        return "Borrador";
      case "pending":
        return "Pend. cita";
      case "abierto":
        return "Pend. Jober";
      case "full":
        return "En proceso";
      case "signaturePending":
        return "Pend. firma";
      case "finalizado":
        return "Firmado";
      case "review":
        return "Valorado";
      case "eliminado":
        return "Eliminado";
      case "falso":
        return "Falso";
    }
  } else if (jobType === "transport") {
    switch (state) {
      case "draft":
        return "Borrador";
      case "pending":
        return "Pend. fecha entrega";
      case "abierto":
        return "Pend. Jober";
      case "full":
        return "En reparto";
      case "signaturePending":
        return "Pend. firma";
      case "finalizado":
        return "Firmado";
      case "review":
        return "Valorado";
      case "eliminado":
        return "Eliminado";
      case "falso":
        return "Falso";
    }
  } else if (jobType === "lead") {
    switch (state) {
      case "abierto":
        return "Abierto";
      case "full":
        return "Lleno";
      case "finalizado":
        return "Finalizado";
      case "review":
        return "Valorado";
      case "eliminado":
        return "Eliminado";
      case "falso":
        return "Falso";
      case "noJobers":
        return "No hay Jobers";
      case "standby":
        return "En espera";
      case "frozen":
        return "Congelado";
    }
  }
}
/**
 * Add new extras to a fixed job
 * @method addNewExtras
 * @name Jobin.Job.addNewExtras
 * @param {ParseObject} job
 * @param {Array} extrasArray Array with the new and old extras
 * @param {string} paymentMethod
 * @param {string} email //optional
 * @param {Object} refoundSummary //optional
 * @param {string} iban //optional
 * @returns {boolean} Success
 */

export function addNewExtras(_x39, _x40, _x41, _x42, _x43, _x44) {
  return _addNewExtras.apply(this, arguments);
}
/**
 * Add weight to a transport job
 * @method addWeight
 * @name Jobin.Job.addWeight
 * @param {ParseObject} transportInfo
 * @param {number} weight New weight to add
 * @param {string} [paymentMethod] Required if weight > 0
 * @param {Object} [summary] Required if weight < 0
 * @param {string} [iban] Required if weight < 0 && summary.transfer > 0
 * @returns {boolean} Success
 */
function _addNewExtras() {
  _addNewExtras = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(job, extrasArray, paymentMethod, email, refoundSummary, iban) {
    var result, fixedInfo, draft, _result7, _fixedInfo, _draft;
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          if (!refoundSummary) {
            _context22.next = 25;
            break;
          }
          _context22.prev = 1;
          _context22.next = 4;
          return Parse.Cloud.run("returnFixedExtras", {
            jobId: job.id,
            extras: extrasArray,
            summary: refoundSummary,
            iban: iban,
            sessionToken: sessionToken.getToken()
          });
        case 4:
          result = _context22.sent;
          if (!result) {
            _context22.next = 16;
            break;
          }
          _context22.next = 8;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(result.fixedObjectId);
        case 8:
          fixedInfo = _context22.sent;
          draft = fixedInfo.get("Job").get("State") === "draft";
          _context22.next = 12;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: !draft ? "gen" : null,
            jober: !draft ? "gen" : null
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical"), fixedInfo.get("RelatedTo"));
        case 12:
          fixedInfo = _context22.sent;
          return _context22.abrupt("return", {
            status: "ok",
            result: true
          });
        case 16:
          return _context22.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar guardar los nuevos extras"
          });
        case 17:
          _context22.next = 23;
          break;
        case 19:
          _context22.prev = 19;
          _context22.t0 = _context22["catch"](1);
          console.error(_context22.t0);
          return _context22.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar guardar los nuevos extras"
          });
        case 23:
          _context22.next = 47;
          break;
        case 25:
          _context22.prev = 25;
          _context22.next = 28;
          return Parse.Cloud.run("changeFixedExtras", {
            jobId: job.id,
            extras: extrasArray,
            paymentMethod: paymentMethod,
            emailForInvoice: email ? email : undefined,
            sessionToken: sessionToken.getToken()
          });
        case 28:
          _result7 = _context22.sent;
          if (!_result7) {
            _context22.next = 40;
            break;
          }
          _context22.next = 32;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(_result7.fixedObjectId);
        case 32:
          _fixedInfo = _context22.sent;
          _draft = _fixedInfo.get("Job").get("State") === "draft";
          _context22.next = 36;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: !_draft ? "gen" : null,
            jober: !_draft ? "gen" : null
          }, _fixedInfo, _fixedInfo.get("Job"), _fixedInfo.get("Job").get("CreatedBy"), _fixedInfo.get("Job").get("Subvertical"), _fixedInfo.get("RelatedTo"));
        case 36:
          _fixedInfo = _context22.sent;
          return _context22.abrupt("return", {
            status: "ok",
            result: true
          });
        case 40:
          return _context22.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar guardar los nuevos extras"
          });
        case 41:
          _context22.next = 47;
          break;
        case 43:
          _context22.prev = 43;
          _context22.t1 = _context22["catch"](25);
          console.error(_context22.t1);
          return _context22.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar guardar los nuevos extras"
          });
        case 47:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[1, 19], [25, 43]]);
  }));
  return _addNewExtras.apply(this, arguments);
}
export function addWeight(_x45, _x46, _x47, _x48, _x49) {
  return _addWeight.apply(this, arguments);
}
/**
 * Get all the includes the job has
 * @method getIncludes
 * @name Jobin.Job.getIncludes
 * @param {ParseObject} job
 * @returns {Array}
 */
function _addWeight() {
  _addWeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(transportInfo, weight, paymentMethod, summary, iban) {
    var currentWeight, newTotalWeight, result, transportation;
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          currentWeight = transportInfo.get("Weight");
          newTotalWeight = Number(currentWeight) + Number(weight);
          if (!summary) {
            _context23.next = 9;
            break;
          }
          _context23.next = 6;
          return Parse.Cloud.run("reduceTransportWeight", {
            jobId: transportInfo.get("Job").id,
            weight: newTotalWeight,
            summary: summary,
            iban: iban,
            sessionToken: sessionToken.getToken()
          });
        case 6:
          result = _context23.sent;
          _context23.next = 12;
          break;
        case 9:
          _context23.next = 11;
          return Parse.Cloud.run("updateCRMTransportation", {
            jobId: transportInfo.get("Job").id,
            weight: newTotalWeight,
            paymentMethod: paymentMethod,
            sessionToken: sessionToken.getToken()
          });
        case 11:
          result = _context23.sent;
        case 12:
          if (!result) {
            _context23.next = 23;
            break;
          }
          if (!weight) {
            _context23.next = 20;
            break;
          }
          _context23.next = 16;
          return new Parse.Query("Transportation").include("Job", "Job.CreatedBy").get(transportInfo.id);
        case 16:
          transportation = _context23.sent;
          _context23.next = 19;
          return PDF.remakeDeliveryNotes({
            user: "gen",
            jobin: "gen",
            jober: "gen",
            warehouse: "gen"
          }, transportation, transportation.get("Job"), transportation.get("Job").get("CreatedBy"), paymentMethod);
        case 19:
          transportation = _context23.sent;
        case 20:
          return _context23.abrupt("return", {
            status: "ok",
            result: true
          });
        case 23:
          return _context23.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar aumentar el peso del transporte"
          });
        case 24:
          _context23.next = 30;
          break;
        case 26:
          _context23.prev = 26;
          _context23.t0 = _context23["catch"](0);
          console.error(_context23.t0);
          return _context23.abrupt("return", {
            status: "error",
            result: "Hubo un fallo inesperado al intentar aumentar el peso del transporte"
          });
        case 30:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 26]]);
  }));
  return _addWeight.apply(this, arguments);
}
export function getIncludes(_x50) {
  return _getIncludes.apply(this, arguments);
}
/**
 * Get all the non includes the job has
 * @method getNonIncludes
 * @name Jobin.Job.getNonIncludes
 * @param {ParseObject} job
 * @returns {Array}
 */
function _getIncludes() {
  _getIncludes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(job) {
    var subvertical, Vertical, query, object;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          subvertical = job.get("Subvertical");
          if (!subvertical) {
            _context24.next = 22;
            break;
          }
          Vertical = Parse.Object.extend("Verticales");
          query = new Parse.Query(Vertical);
          query.equalTo("objectId", subvertical.id);
          _context24.prev = 5;
          _context24.next = 8;
          return query.first();
        case 8:
          object = _context24.sent;
          if (!object) {
            _context24.next = 13;
            break;
          }
          return _context24.abrupt("return", {
            status: "ok",
            result: object.get("Includes")
          });
        case 13:
          return _context24.abrupt("return", {
            status: "error",
            result: "Hubo un fallo al intentar descargar qué incluye el trabajo."
          });
        case 14:
          _context24.next = 20;
          break;
        case 16:
          _context24.prev = 16;
          _context24.t0 = _context24["catch"](5);
          console.error(_context24.t0);
          return _context24.abrupt("return", {
            status: "error",
            result: "Hubo un fallo al intentar descargar qué incluye el trabajo."
          });
        case 20:
          _context24.next = 23;
          break;
        case 22:
          return _context24.abrupt("return", {
            status: "ok",
            result: []
          });
        case 23:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[5, 16]]);
  }));
  return _getIncludes.apply(this, arguments);
}
export function getNonIncludes(_x51) {
  return _getNonIncludes.apply(this, arguments);
}
/**
 * Change the appointment of a fixed job
 * @method changeAppointment
 * @name Jobin.Job.changeAppointment
 * @param {ParseObject} job
 * @param {Date} date
 * @returns {boolean} Success
 */
function _getNonIncludes() {
  _getNonIncludes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(job) {
    var subvertical, Vertical, query, object;
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          subvertical = job.get("Subvertical");
          if (!subvertical) {
            _context25.next = 22;
            break;
          }
          Vertical = Parse.Object.extend("Verticales");
          query = new Parse.Query(Vertical);
          query.equalTo("objectId", subvertical.id);
          _context25.prev = 5;
          _context25.next = 8;
          return query.first();
        case 8:
          object = _context25.sent;
          if (!object) {
            _context25.next = 13;
            break;
          }
          return _context25.abrupt("return", {
            status: "ok",
            result: object.get("DoesntInclude")
          });
        case 13:
          return _context25.abrupt("return", {
            status: "error",
            result: "Hubo un fallo al intentar descargar qué incluye el trabajo."
          });
        case 14:
          _context25.next = 20;
          break;
        case 16:
          _context25.prev = 16;
          _context25.t0 = _context25["catch"](5);
          console.error(_context25.t0);
          return _context25.abrupt("return", {
            status: "error",
            result: "Hubo un fallo al intentar descargar qué incluye el trabajo."
          });
        case 20:
          _context25.next = 23;
          break;
        case 22:
          return _context25.abrupt("return", {
            status: "ok",
            result: []
          });
        case 23:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[5, 16]]);
  }));
  return _getNonIncludes.apply(this, arguments);
}
export function changeAppointment(_x52, _x53) {
  return _changeAppointment.apply(this, arguments);
}
/**
 * Change the price to pay to the Jober
 * @method changeJoberPrice
 * @name Jobin.Job.changeJoberPrice
 * @param {ParseObject} job
 * @param {Number} price
 * @returns {boolean} Success
 */
function _changeAppointment() {
  _changeAppointment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(job, date) {
    var jobType, result, _result8;
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          jobType = job.get("JobType");
          if (!(jobType === "transport")) {
            _context26.next = 19;
            break;
          }
          _context26.prev = 2;
          _context26.next = 5;
          return Parse.Cloud.run("changeTransportAppointment", {
            jobId: job.id,
            date: date,
            sessionToken: sessionToken.getToken()
          });
        case 5:
          result = _context26.sent;
          if (!result) {
            _context26.next = 10;
            break;
          }
          return _context26.abrupt("return", {
            status: "ok",
            result: true
          });
        case 10:
          return _context26.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de modificar la fecha de entrega."
          });
        case 11:
          _context26.next = 17;
          break;
        case 13:
          _context26.prev = 13;
          _context26.t0 = _context26["catch"](2);
          console.error(_context26.t0);
          return _context26.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de modificar la fecha de entrega."
          });
        case 17:
          _context26.next = 38;
          break;
        case 19:
          if (!(jobType === "fixed")) {
            _context26.next = 37;
            break;
          }
          _context26.prev = 20;
          _context26.next = 23;
          return Parse.Cloud.run("changeFixedAppointment", {
            jobId: job.id,
            date: date,
            from: "crm",
            sessionToken: sessionToken.getToken()
          });
        case 23:
          _result8 = _context26.sent;
          if (!_result8) {
            _context26.next = 28;
            break;
          }
          return _context26.abrupt("return", {
            status: "ok",
            result: true
          });
        case 28:
          return _context26.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de cambiar la cita del trabajo."
          });
        case 29:
          _context26.next = 35;
          break;
        case 31:
          _context26.prev = 31;
          _context26.t1 = _context26["catch"](20);
          console.error(_context26.t1);
          return _context26.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de cambiar la cita del trabajo."
          });
        case 35:
          _context26.next = 38;
          break;
        case 37:
          return _context26.abrupt("return", {
            status: "error",
            result: "No es posible cambiar la fecha de la cita a este tipo de trabajos"
          });
        case 38:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[2, 13], [20, 31]]);
  }));
  return _changeAppointment.apply(this, arguments);
}
export function changeJoberPrice(_x54, _x55) {
  return _changeJoberPrice.apply(this, arguments);
}
/**
 * Send a transportation to transit
 * @method sendToTransit
 * @name Jobin.Job.sendToTransit
 * @param {ParseObject} jobsArray The id of the jobs you want to send to transit
 * @param {ParseObject} jober The transportist
 * @returns {boolean} Success
 */
function _changeJoberPrice() {
  _changeJoberPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(job, price) {
    var jobType, result, _result9;
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          jobType = job.get("JobType");
          if (!(jobType === "transport")) {
            _context27.next = 19;
            break;
          }
          _context27.prev = 2;
          _context27.next = 5;
          return Parse.Cloud.run("changeTransportJoberPrice", {
            jobId: job.id,
            joberPrice: price,
            sessionToken: sessionToken.getToken()
          });
        case 5:
          result = _context27.sent;
          if (!result) {
            _context27.next = 10;
            break;
          }
          return _context27.abrupt("return", {
            status: "ok",
            result: true
          });
        case 10:
          return _context27.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de modificar el precio del Jober."
          });
        case 11:
          _context27.next = 17;
          break;
        case 13:
          _context27.prev = 13;
          _context27.t0 = _context27["catch"](2);
          console.error(_context27.t0);
          return _context27.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de modificar el precio del Jober."
          });
        case 17:
          _context27.next = 38;
          break;
        case 19:
          if (!(jobType === "fixed")) {
            _context27.next = 37;
            break;
          }
          _context27.prev = 20;
          _context27.next = 23;
          return Parse.Cloud.run("changeFixedJoberPrice", {
            jobId: job.id,
            joberPrice: price,
            sessionToken: sessionToken.getToken()
          });
        case 23:
          _result9 = _context27.sent;
          if (!_result9) {
            _context27.next = 28;
            break;
          }
          return _context27.abrupt("return", {
            status: "ok",
            result: true
          });
        case 28:
          return _context27.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de modificar el precio del Jober."
          });
        case 29:
          _context27.next = 35;
          break;
        case 31:
          _context27.prev = 31;
          _context27.t1 = _context27["catch"](20);
          console.error(_context27.t1);
          return _context27.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de modificar el precio del Jober."
          });
        case 35:
          _context27.next = 38;
          break;
        case 37:
          return _context27.abrupt("return", {
            status: "error",
            result: "No es posible cambiar el precio a este tipo de trabajos."
          });
        case 38:
        case "end":
          return _context27.stop();
      }
    }, _callee27, null, [[2, 13], [20, 31]]);
  }));
  return _changeJoberPrice.apply(this, arguments);
}
export function sendToTransit(_x56, _x57) {
  return _sendToTransit.apply(this, arguments);
}
/**
 * Remake fixed job notes
 * @method remakeNotes
 * @name Jobin.Job.remakeNotes
 * @param {string} fixedId FixedInfo object id
 * @returns {boolean} Success
 */
function _sendToTransit() {
  _sendToTransit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(jobsArray, jober) {
    var result, deliveryId, _result10;
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.prev = 0;
          _context28.next = 3;
          return Parse.Cloud.run("sendTransportationToTransit", {
            joberId: jober.id,
            generatedIds: jobsArray,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context28.sent;
          if (!result) {
            _context28.next = 23;
            break;
          }
          deliveryId = result;
          _context28.prev = 6;
          _context28.next = 9;
          return Parse.Cloud.run("sendDelivery", {
            deliveryId: deliveryId,
            sessionToken: sessionToken.getToken()
          });
        case 9:
          _result10 = _context28.sent;
          if (!_result10) {
            _context28.next = 14;
            break;
          }
          return _context28.abrupt("return", {
            status: "ok",
            result: true
          });
        case 14:
          return _context28.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de regenerar los albaranes del trabajo."
          });
        case 15:
          _context28.next = 21;
          break;
        case 17:
          _context28.prev = 17;
          _context28.t0 = _context28["catch"](6);
          console.error(_context28.t0);
          return _context28.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de poner el transporte en reparto."
          });
        case 21:
          _context28.next = 24;
          break;
        case 23:
          return _context28.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de regenerar los albaranes del trabajo."
          });
        case 24:
          _context28.next = 30;
          break;
        case 26:
          _context28.prev = 26;
          _context28.t1 = _context28["catch"](0);
          console.error(_context28.t1);
          return _context28.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de poner el transporte en reparto."
          });
        case 30:
        case "end":
          return _context28.stop();
      }
    }, _callee28, null, [[0, 26], [6, 17]]);
  }));
  return _sendToTransit.apply(this, arguments);
}
export function remakeFixedNotes(_x58) {
  return _remakeFixedNotes.apply(this, arguments);
}
/**
 * Remake transport job notes
 * @method remakeTransportNotes
 * @name Jobin.Job.remakeTransportNotes
 * @param {string} transportationId Transport object id
 * @returns {boolean} Success
 */
function _remakeFixedNotes() {
  _remakeFixedNotes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(fixedId) {
    var fixedInfo, draft;
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          _context29.next = 3;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(fixedId);
        case 3:
          fixedInfo = _context29.sent;
          draft = fixedInfo.get("Job").get("State") === "draft";
          _context29.next = 7;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: !draft ? "gen" : "del",
            jober: !draft ? "gen" : "del"
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical"), fixedInfo.get("RelatedTo"));
        case 7:
          fixedInfo = _context29.sent;
          return _context29.abrupt("return", {
            status: "ok",
            result: {
              userPDF: fixedInfo.has("UserNote") ? fixedInfo.get("UserNote").url() : undefined,
              jobinPDF: fixedInfo.has("JobinNote") ? fixedInfo.get("JobinNote").url() : undefined,
              joberPDF: fixedInfo.has("JoberNote") ? fixedInfo.get("JoberNote").url() : undefined
            }
          });
        case 11:
          _context29.prev = 11;
          _context29.t0 = _context29["catch"](0);
          console.error(_context29.t0);
          return _context29.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de regenerar los albaranes del trabajo."
          });
        case 15:
        case "end":
          return _context29.stop();
      }
    }, _callee29, null, [[0, 11]]);
  }));
  return _remakeFixedNotes.apply(this, arguments);
}
export function remakeTransportNotes(_x59) {
  return _remakeTransportNotes.apply(this, arguments);
}
/**
 * Remake transport job notes
 * @method publishDraftJob
 * @name Jobin.Job.publishDraftJob
 * @param {ParseObject} job
 * @param {string} paymentMethod
 * @param {string} email //optional
 * @returns {boolean} Success
 */
function _remakeTransportNotes() {
  _remakeTransportNotes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(transportationId) {
    var transportation, payment;
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.prev = 0;
          _context30.next = 3;
          return new Parse.Query("Transportation").include("Job", "Job.CreatedBy").get(transportationId);
        case 3:
          transportation = _context30.sent;
          _context30.next = 6;
          return new Parse.Query("Payments").equalTo("Job", transportation.get("Job")).first();
        case 6:
          payment = _context30.sent;
          _context30.next = 9;
          return PDF.remakeDeliveryNotes({
            user: "gen",
            jobin: "gen",
            jober: "gen",
            warehouse: "gen"
          }, transportation, transportation.get("Job"), transportation.get("Job").get("CreatedBy"), payment.get("Method"));
        case 9:
          transportation = _context30.sent;
          return _context30.abrupt("return", {
            status: "ok",
            result: true
          });
        case 13:
          _context30.prev = 13;
          _context30.t0 = _context30["catch"](0);
          console.error(_context30.t0);
          return _context30.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de regenerar los albaranes del transporte."
          });
        case 17:
        case "end":
          return _context30.stop();
      }
    }, _callee30, null, [[0, 13]]);
  }));
  return _remakeTransportNotes.apply(this, arguments);
}
export function publishDraftJob(_x60, _x61, _x62) {
  return _publishDraftJob.apply(this, arguments);
}
/**
 * Add new extras to a draft job
 * @method addNewExtrasToDrafJob
 * @name Jobin.Job.addNewExtrasToDrafJob
 * @param {ParseObject} job
 * @param {ParseObject} fixedInfo
 * @param {Array} extrasArray
 * @returns {boolean} Success
 */
function _publishDraftJob() {
  _publishDraftJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(job, paymentMethod, email) {
    var result, fixedInfo;
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.prev = 0;
          _context31.next = 3;
          return Parse.Cloud.run("publishFixedDraft", {
            jobId: job.id,
            paymentMethod: paymentMethod,
            emailForInvoice: email,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context31.sent;
          if (!result) {
            _context31.next = 14;
            break;
          }
          _context31.next = 7;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(result.fixedObjectId);
        case 7:
          fixedInfo = _context31.sent;
          _context31.next = 10;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: "gen",
            jober: "gen"
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical"), fixedInfo.get("RelatedTo"));
        case 10:
          fixedInfo = _context31.sent;
          return _context31.abrupt("return", {
            status: "ok",
            result: _objectSpread({}, result, {
              userPDF: fixedInfo.has("UserNote") ? fixedInfo.get("UserNote").url() : undefined,
              jobinPDF: fixedInfo.has("JobinNote") ? fixedInfo.get("JobinNote").url() : undefined,
              joberPDF: fixedInfo.has("JoberNote") ? fixedInfo.get("JoberNote").url() : undefined
            })
          });
        case 14:
          return _context31.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de publicar este trabajo. Inténtalo de nuevo más tarde."
          });
        case 15:
          _context31.next = 21;
          break;
        case 17:
          _context31.prev = 17;
          _context31.t0 = _context31["catch"](0);
          console.error(_context31.t0);
          return _context31.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de publicar este trabajo. Inténtalo de nuevo más tarde."
          });
        case 21:
        case "end":
          return _context31.stop();
      }
    }, _callee31, null, [[0, 17]]);
  }));
  return _publishDraftJob.apply(this, arguments);
}
export function addNewExtrasToDraftJob(_x63, _x64) {
  return _addNewExtrasToDraftJob.apply(this, arguments);
}
/**
 * Freeze a job
 * @method freeze
 * @name Jobin.Job.freeze
 * @param {ParseObject} job
 * @returns {boolean} Success
 */
function _addNewExtrasToDraftJob() {
  _addNewExtrasToDraftJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(job, extrasArray) {
    var result, fixedInfo;
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.prev = 0;
          _context32.next = 3;
          return Parse.Cloud.run("changeFixedExtrasForDraft", {
            jobId: job.id,
            extras: extrasArray,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context32.sent;
          if (!result) {
            _context32.next = 14;
            break;
          }
          _context32.next = 7;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(result.fixedObjectId);
        case 7:
          fixedInfo = _context32.sent;
          _context32.next = 10;
          return PDF.remakeFixedNotes({
            user: "gen"
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical"), fixedInfo.get("RelatedTo"));
        case 10:
          fixedInfo = _context32.sent;
          return _context32.abrupt("return", {
            status: "ok",
            result: _objectSpread({}, result, {
              userPDF: fixedInfo.has("UserNote") ? fixedInfo.get("UserNote").url() : undefined,
              jobinPDF: fixedInfo.has("JobinNote") ? fixedInfo.get("JobinNote").url() : undefined,
              joberPDF: fixedInfo.has("JoberNote") ? fixedInfo.get("JoberNote").url() : undefined
            })
          });
        case 14:
          return _context32.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no se han podido guardar los extras. Inténtalo de nuevo más tarde."
          });
        case 15:
          _context32.next = 21;
          break;
        case 17:
          _context32.prev = 17;
          _context32.t0 = _context32["catch"](0);
          console.error(_context32.t0);
          return _context32.abrupt("return", {
            status: "error",
            result: "Algo ha fallado y no se han podido guardar los extras. Inténtalo de nuevo más tarde."
          });
        case 21:
        case "end":
          return _context32.stop();
      }
    }, _callee32, null, [[0, 17]]);
  }));
  return _addNewExtrasToDraftJob.apply(this, arguments);
}
export function freeze(_x65) {
  return _freeze.apply(this, arguments);
}
/**
 * Unfreeze and publish a job
 * @method unfreeze
 * @name Jobin.Job.unfreeze
 * @param {ParseObject} job
 * @returns {boolean} Success
 */
function _freeze() {
  _freeze = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.prev = 0;
          _context33.next = 3;
          return Parse.Cloud.run("freezeJobs", {
            jobIds: [job.id],
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context33.sent;
          if (!result) {
            _context33.next = 8;
            break;
          }
          return _context33.abrupt("return", {
            status: "ok",
            result: true
          });
        case 8:
          return _context33.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de congelar el servicio."
          });
        case 9:
          _context33.next = 15;
          break;
        case 11:
          _context33.prev = 11;
          _context33.t0 = _context33["catch"](0);
          console.error(_context33.t0);
          return _context33.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de congelar el servicio."
          });
        case 15:
        case "end":
          return _context33.stop();
      }
    }, _callee33, null, [[0, 11]]);
  }));
  return _freeze.apply(this, arguments);
}
export function unfreeze(_x66) {
  return _unfreeze.apply(this, arguments);
}
/**
 * publish a job of type lead
 * @method createLeadJob
 * @name Jobin.Job.createLeadJob
 * @param {string} userId
 * @param {string} guildId
 * @param {string} guildType
 * @param {string} subCategoryId
 * @param {Double} lat
 * @param {Double} lng
 * @param {string} description
 * @param {Array} imgArr
 * @param {string} priority
 * @param {string} fromIntegration
 * @param {string} businessId
 * @returns {Object} Success
 */
function _unfreeze() {
  _unfreeze = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(job) {
    var result;
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.prev = 0;
          _context34.next = 3;
          return Parse.Cloud.run("unfreezeAndPublishJobs", {
            jobIds: [job.id],
            sessionToken: sessionToken.getToken()
          });
        case 3:
          result = _context34.sent;
          if (!result) {
            _context34.next = 8;
            break;
          }
          return _context34.abrupt("return", {
            status: "ok",
            result: true
          });
        case 8:
          return _context34.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de descongelar el servicio."
          });
        case 9:
          _context34.next = 15;
          break;
        case 11:
          _context34.prev = 11;
          _context34.t0 = _context34["catch"](0);
          console.error(_context34.t0);
          return _context34.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de descongelar el servicio."
          });
        case 15:
        case "end":
          return _context34.stop();
      }
    }, _callee34, null, [[0, 11]]);
  }));
  return _unfreeze.apply(this, arguments);
}
export function createLeadJob(_x67, _x68, _x69, _x70, _x71, _x72, _x73, _x74, _x75) {
  return _createLeadJob.apply(this, arguments);
}
/**
 * publish a job of type transportation
 * @method createTransportJob
 * @name Jobin.Job.createTransportJob
 * @param {string} userId
 * @param {string} guildId
 * @param {string} guildType
 * @param {string} subCategoryId
 * @param {Double} lat
 * @param {Double} lng
 * @param {integer} weight
 * @param {float} price
 * @param {string} description
 * @param {Array} imgArr
 * @param {string} paymentMethod
 * @param {string} fromIntegration
 * @param {string} fromWeb
 * @param {integer} level
 * @param {string} address
 * @param {string} businessId
 * @param {Date} deliveryDate
 * @returns {Object} Success
 */
function _createLeadJob() {
  _createLeadJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(userId, guildId, guildType, subCategoryId, lat, lng, description, imgArr, priority) {
    var fromIntegration,
      businessId,
      imgUrlPromise,
      result,
      _args35 = arguments;
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          fromIntegration = _args35.length > 9 && _args35[9] !== undefined ? _args35[9] : "web";
          businessId = _args35.length > 10 ? _args35[10] : undefined;
          if (!(guildId && guildType && lat && lng)) {
            _context35.next = 46;
            break;
          }
          imgUrlPromise = imgArr && imgArr.length > 0 ? image.imageParser(imgArr) : [];
          _context35.prev = 4;
          _context35.t0 = Parse.Cloud;
          _context35.t1 = userId;
          _context35.t2 = guildId;
          _context35.t3 = guildType;
          _context35.t4 = subCategoryId;
          _context35.t5 = lat;
          _context35.t6 = lng;
          _context35.t7 = description;
          if (!(imgUrlPromise.length > 0)) {
            _context35.next = 19;
            break;
          }
          _context35.next = 16;
          return Promise.all(imgUrlPromise);
        case 16:
          _context35.t8 = _context35.sent;
          _context35.next = 20;
          break;
        case 19:
          _context35.t8 = undefined;
        case 20:
          _context35.t9 = _context35.t8;
          _context35.t10 = priority;
          _context35.t11 = fromIntegration;
          _context35.t12 = businessId;
          _context35.t13 = sessionToken.getToken();
          _context35.t14 = {
            userId: _context35.t1,
            verticalId: _context35.t2,
            verticalType: _context35.t3,
            subCategoryId: _context35.t4,
            latitud: _context35.t5,
            longitud: _context35.t6,
            description: _context35.t7,
            images: _context35.t9,
            priority: _context35.t10,
            fromIntegration: _context35.t11,
            businessId: _context35.t12,
            sessionToken: _context35.t13
          };
          _context35.next = 28;
          return _context35.t0.run.call(_context35.t0, "createJob", _context35.t14);
        case 28:
          result = _context35.sent;
          if (!result) {
            _context35.next = 33;
            break;
          }
          return _context35.abrupt("return", {
            status: "ok",
            result: result
          });
        case 33:
          return _context35.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 34:
          _context35.next = 44;
          break;
        case 36:
          _context35.prev = 36;
          _context35.t15 = _context35["catch"](4);
          console.error(_context35.t15);
          if (!_context35.t15.toString().split(" ").includes("NO_JOBERS")) {
            _context35.next = 43;
            break;
          }
          return _context35.abrupt("return", {
            status: "error",
            result: "No se han encontrado Jobers para este trabajo."
          });
        case 43:
          return _context35.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 44:
          _context35.next = 47;
          break;
        case 46:
          return _context35.abrupt("return", {
            status: "error",
            result: "los parametros guildId, guildType, lat y lng son obligatorios."
          });
        case 47:
        case "end":
          return _context35.stop();
      }
    }, _callee35, null, [[4, 36]]);
  }));
  return _createLeadJob.apply(this, arguments);
}
export function createTransportJob(_x76, _x77, _x78, _x79, _x80, _x81, _x82, _x83, _x84, _x85, _x86) {
  return _createTransportJob.apply(this, arguments);
}
/**
 * publish a job of type fixed
 * @method createFixedJob
 * @name Jobin.Job.createFixedJob
 * @param {string} userId
 * @param {string} guildId
 * @param {string} guildType
 * @param {string} subCategoryId
 * @param {Double} lat
 * @param {Double} lng
 * @param {Array} extrasArr
 * @param {string} description
 * @param {Array} imgArr
 * @param {string} priority
 * @param {string} paymentMethod
 * @param {string} fromIntegration
 * @param {string} fromWeb
 * @param {integer} level
 * @param {integer} address
 * @param {integer} emailForInvoice
 * @param {boolean} draft
 * @param {string} businessId
 * @param {Date} availableTo
 * @returns {Object} Success
 */
function _createTransportJob() {
  _createTransportJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(userId, guildId, guildType, subCategoryId, lat, lng, weight, price, description, imgArr, paymentMethod) {
    var fromIntegration,
      fromWeb,
      level,
      address,
      businessId,
      deliveryDate,
      imgUrlPromise,
      result,
      transportation,
      payment,
      _args36 = arguments;
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          fromIntegration = _args36.length > 11 && _args36[11] !== undefined ? _args36[11] : "bi-web";
          fromWeb = _args36.length > 12 && _args36[12] !== undefined ? _args36[12] : true;
          level = _args36.length > 13 && _args36[13] !== undefined ? _args36[13] : 3;
          address = _args36.length > 14 ? _args36[14] : undefined;
          businessId = _args36.length > 15 ? _args36[15] : undefined;
          deliveryDate = _args36.length > 16 ? _args36[16] : undefined;
          if (!(guildId && guildType && lat && lng && weight && paymentMethod)) {
            _context36.next = 65;
            break;
          }
          imgUrlPromise = imgArr && imgArr.length > 0 ? image.imageParser(imgArr) : [];
          _context36.prev = 8;
          _context36.t0 = Parse.Cloud;
          _context36.t1 = userId;
          _context36.t2 = sessionToken.getToken();
          _context36.t3 = guildId;
          _context36.t4 = guildType;
          _context36.t5 = subCategoryId;
          _context36.t6 = lat;
          _context36.t7 = lng;
          _context36.t8 = weight;
          _context36.t9 = price;
          _context36.t10 = description;
          if (!(imgUrlPromise.length > 0)) {
            _context36.next = 26;
            break;
          }
          _context36.next = 23;
          return Promise.all(imgUrlPromise);
        case 23:
          _context36.t11 = _context36.sent;
          _context36.next = 27;
          break;
        case 26:
          _context36.t11 = undefined;
        case 27:
          _context36.t12 = _context36.t11;
          _context36.t13 = paymentMethod;
          _context36.t14 = fromIntegration;
          _context36.t15 = fromWeb;
          _context36.t16 = level;
          _context36.t17 = address;
          _context36.t18 = businessId;
          _context36.t19 = deliveryDate;
          _context36.t20 = {
            userId: _context36.t1,
            sessionToken: _context36.t2,
            verticalId: _context36.t3,
            verticalType: _context36.t4,
            subCategoryId: _context36.t5,
            latitud: _context36.t6,
            longitud: _context36.t7,
            weight: _context36.t8,
            price: _context36.t9,
            description: _context36.t10,
            images: _context36.t12,
            paymentMethod: _context36.t13,
            fromIntegration: _context36.t14,
            fromWeb: _context36.t15,
            level: _context36.t16,
            address: _context36.t17,
            businessId: _context36.t18,
            deliveryDate: _context36.t19
          };
          _context36.next = 38;
          return _context36.t0.run.call(_context36.t0, "createInstantJob", _context36.t20);
        case 38:
          result = _context36.sent;
          if (!result) {
            _context36.next = 52;
            break;
          }
          _context36.next = 42;
          return new Parse.Query("Transportation").include("Job", "Job.CreatedBy").get(result.transportationObjectId);
        case 42:
          transportation = _context36.sent;
          _context36.next = 45;
          return new Parse.Query("Payments").equalTo("Job", Parse.Object.extend("Jobs").createWithoutData(result.job)).first();
        case 45:
          payment = _context36.sent;
          _context36.next = 48;
          return PDF.remakeDeliveryNotes({
            user: "gen",
            jobin: "gen",
            jober: "gen",
            warehouse: "gen"
          }, transportation, transportation.get("Job"), transportation.get("Job").get("CreatedBy"), payment.get("Method"));
        case 48:
          transportation = _context36.sent;
          return _context36.abrupt("return", {
            status: "ok",
            result: _objectSpread({}, result, {
              userPDF: transportation.has("UserNote") ? transportation.get("UserNote").url() : undefined,
              jobinPDF: transportation.has("JobinNote") ? transportation.get("JobinNote").url() : undefined,
              joberPDF: transportation.has("JoberNote") ? transportation.get("JoberNote").url() : undefined,
              warehousePDF: transportation.has("WarehouseNote") ? transportation.get("WarehouseNote").url() : undefined
            })
          });
        case 52:
          return _context36.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 53:
          _context36.next = 63;
          break;
        case 55:
          _context36.prev = 55;
          _context36.t21 = _context36["catch"](8);
          console.error(_context36.t21);
          if (!_context36.t21.toString().split(" ").includes("NO_JOBERS")) {
            _context36.next = 62;
            break;
          }
          return _context36.abrupt("return", {
            status: "error",
            result: "No se han encontrado Jobers para este trabajo."
          });
        case 62:
          return _context36.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 63:
          _context36.next = 66;
          break;
        case 65:
          return _context36.abrupt("return", {
            status: "error",
            result: "los parametros guildId, guildType, lat, lng, weight y paymentMethod son obligatorios."
          });
        case 66:
        case "end":
          return _context36.stop();
      }
    }, _callee36, null, [[8, 55]]);
  }));
  return _createTransportJob.apply(this, arguments);
}
export function createFixedJob(_x87, _x88, _x89, _x90, _x91, _x92, _x93, _x94, _x95, _x96, _x97) {
  return _createFixedJob.apply(this, arguments);
}
/**
 * transform a job of type lead to a job of type fixed
 * @method transformLeadToFixed
 * @name Jobin.Job.transformLeadToFixed
 * @param {Double} lat
 * @param {Double} lng
 * @param {integer} address
 * @param {string} jobId
 * @param {string} paymentMethod
 * @param {boolean} draft
 * @param {integer} emailForInvoice
 * @param {Array} extras
 * @param {Date} availableFrom
 * @param {Date} availableTo
 * @param {string} businessId
 * @returns {Object} Success
 */
function _createFixedJob() {
  _createFixedJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(userId, guildId, guildType, subCategoryId, lat, lng, extrasArr, description, imgArr, priority, paymentMethod) {
    var fromIntegration,
      fromWeb,
      level,
      address,
      emailForInvoice,
      draft,
      businessId,
      availableTo,
      appointmentSchedule,
      priceMultiplier,
      assetId,
      isPriceZero,
      imgUrlPromise,
      result,
      fixedInfo,
      _args37 = arguments;
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          fromIntegration = _args37.length > 11 && _args37[11] !== undefined ? _args37[11] : "bi-web";
          fromWeb = _args37.length > 12 && _args37[12] !== undefined ? _args37[12] : true;
          level = _args37.length > 13 ? _args37[13] : undefined;
          address = _args37.length > 14 ? _args37[14] : undefined;
          emailForInvoice = _args37.length > 15 ? _args37[15] : undefined;
          draft = _args37.length > 16 ? _args37[16] : undefined;
          businessId = _args37.length > 17 ? _args37[17] : undefined;
          availableTo = _args37.length > 18 ? _args37[18] : undefined;
          appointmentSchedule = _args37.length > 19 ? _args37[19] : undefined;
          priceMultiplier = _args37.length > 20 ? _args37[20] : undefined;
          assetId = _args37.length > 21 && _args37[21] !== undefined ? _args37[21] : null;
          isPriceZero = _args37.length > 22 ? _args37[22] : undefined;
          if (!(guildId && guildType && lat && lng && address)) {
            _context37.next = 74;
            break;
          }
          imgUrlPromise = imgArr && imgArr.length > 0 ? image.imageParser(imgArr) : [];
          _context37.prev = 14;
          _context37.t0 = Parse.Cloud;
          _context37.t1 = userId;
          _context37.t2 = sessionToken.getToken();
          _context37.t3 = guildId;
          _context37.t4 = guildType;
          _context37.t5 = subCategoryId;
          _context37.t6 = lat;
          _context37.t7 = lng;
          _context37.t8 = extrasArr;
          _context37.t9 = description;
          if (!(imgUrlPromise.length > 0)) {
            _context37.next = 31;
            break;
          }
          _context37.next = 28;
          return Promise.all(imgUrlPromise);
        case 28:
          _context37.t10 = _context37.sent;
          _context37.next = 32;
          break;
        case 31:
          _context37.t10 = undefined;
        case 32:
          _context37.t11 = _context37.t10;
          _context37.t12 = priority;
          _context37.t13 = paymentMethod;
          _context37.t14 = fromIntegration;
          _context37.t15 = fromWeb;
          _context37.t16 = level;
          _context37.t17 = address;
          _context37.t18 = emailForInvoice;
          _context37.t19 = draft;
          _context37.t20 = businessId;
          _context37.t21 = availableTo;
          _context37.t22 = appointmentSchedule;
          _context37.t23 = priceMultiplier;
          _context37.t24 = assetId;
          _context37.t25 = isPriceZero;
          _context37.t26 = {
            userId: _context37.t1,
            sessionToken: _context37.t2,
            verticalId: _context37.t3,
            verticalType: _context37.t4,
            subCategoryId: _context37.t5,
            latitud: _context37.t6,
            longitud: _context37.t7,
            extras: _context37.t8,
            description: _context37.t9,
            images: _context37.t11,
            priority: _context37.t12,
            paymentMethod: _context37.t13,
            fromIntegration: _context37.t14,
            fromWeb: _context37.t15,
            level: _context37.t16,
            address: _context37.t17,
            emailForInvoice: _context37.t18,
            draft: _context37.t19,
            businessId: _context37.t20,
            availableTo: _context37.t21,
            appointmentSchedule: _context37.t22,
            priceMultiplier: _context37.t23,
            assetId: _context37.t24,
            isPriceZero: _context37.t25
          };
          _context37.next = 50;
          return _context37.t0.run.call(_context37.t0, "createFixedJob", _context37.t26);
        case 50:
          result = _context37.sent;
          if (!result) {
            _context37.next = 61;
            break;
          }
          _context37.next = 54;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(result.fixedObjectId);
        case 54:
          fixedInfo = _context37.sent;
          _context37.next = 57;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: !draft ? "gen" : null,
            jober: !draft ? "gen" : null
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical") ? fixedInfo.get("Job").get("Subvertical") : fixedInfo.get("Job").get("Vertical"), fixedInfo.get("RelatedTo"));
        case 57:
          fixedInfo = _context37.sent;
          return _context37.abrupt("return", {
            status: "ok",
            result: _objectSpread({}, result, {
              userPDF: fixedInfo.has("UserNote") ? fixedInfo.get("UserNote").url() : undefined,
              jobinPDF: fixedInfo.has("JobinNote") ? fixedInfo.get("JobinNote").url() : undefined,
              joberPDF: fixedInfo.has("JoberNote") ? fixedInfo.get("JoberNote").url() : undefined
            })
          });
        case 61:
          return _context37.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 62:
          _context37.next = 72;
          break;
        case 64:
          _context37.prev = 64;
          _context37.t27 = _context37["catch"](14);
          console.error(_context37.t27);
          if (!_context37.t27.toString().split(" ").includes("NO_JOBERS")) {
            _context37.next = 71;
            break;
          }
          return _context37.abrupt("return", {
            status: "error",
            result: "No se han encontrado Jobers para este trabajo."
          });
        case 71:
          return _context37.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 72:
          _context37.next = 75;
          break;
        case 74:
          return _context37.abrupt("return", {
            status: "error",
            result: "los parametros guildId, guildType, subCategoryId, lat, lng y address son obligatorios."
          });
        case 75:
        case "end":
          return _context37.stop();
      }
    }, _callee37, null, [[14, 64]]);
  }));
  return _createFixedJob.apply(this, arguments);
}
export function transformLeadToFixed(_x98, _x99, _x100, _x101, _x102, _x103, _x104, _x105, _x106, _x107, _x108) {
  return _transformLeadToFixed.apply(this, arguments);
}
/**
 * updates the Job with files attached by the CRMUser for better legibility
 * @method attachFilesToJob
 * @name Jobin.Job.attachFilesToJob
 * @param {string} jobId
 * @param {Array} files
 * @returns {Object} Success
 */
function _transformLeadToFixed() {
  _transformLeadToFixed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(lat, lng, address, jobId, paymentMethod, draft, emailForInvoice, extras, availableFrom, availableTo, businessId) {
    var result, fixedInfo;
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          if (!(lat && lng && address && jobId)) {
            _context38.next = 28;
            break;
          }
          _context38.prev = 1;
          _context38.next = 4;
          return Parse.Cloud.run("transformLeadToFixed", {
            latitud: lat,
            longitud: lng,
            address: address,
            jobId: jobId,
            paymentMethod: paymentMethod,
            draft: draft,
            emailForInvoice: emailForInvoice,
            extras: extras,
            availableFrom: availableFrom,
            availableTo: availableTo,
            sessionToken: sessionToken.getToken(),
            businessId: businessId
          });
        case 4:
          result = _context38.sent;
          if (!result) {
            _context38.next = 15;
            break;
          }
          _context38.next = 8;
          return new Parse.Query("FixedInfo").include("Job", "Job.CreatedBy", "Job.Subvertical", "RelatedTo").get(result.fixedObjectId);
        case 8:
          fixedInfo = _context38.sent;
          _context38.next = 11;
          return PDF.remakeFixedNotes({
            user: "gen",
            jobin: !draft ? "gen" : null,
            jober: !draft ? "gen" : null
          }, fixedInfo, fixedInfo.get("Job"), fixedInfo.get("Job").get("CreatedBy"), fixedInfo.get("Job").get("Subvertical"), fixedInfo.get("RelatedTo"));
        case 11:
          fixedInfo = _context38.sent;
          return _context38.abrupt("return", {
            status: "ok",
            result: result
          });
        case 15:
          return _context38.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de transformar el trabajo."
          });
        case 16:
          _context38.next = 26;
          break;
        case 18:
          _context38.prev = 18;
          _context38.t0 = _context38["catch"](1);
          console.log(_context38.t0);
          if (!_context38.t0.toString().split(" ").includes("NO_JOBERS")) {
            _context38.next = 25;
            break;
          }
          return _context38.abrupt("return", {
            status: "error",
            result: "No se han encontrado Jobers para este trabajo."
          });
        case 25:
          return _context38.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de crear el trabajo."
          });
        case 26:
          _context38.next = 29;
          break;
        case 28:
          return _context38.abrupt("return", {
            status: "error",
            result: "los parametros lat, lng, address, jobId son obligatorios."
          });
        case 29:
        case "end":
          return _context38.stop();
      }
    }, _callee38, null, [[1, 18]]);
  }));
  return _transformLeadToFixed.apply(this, arguments);
}
export function attachFilesToJob(_x109, _x110) {
  return _attachFilesToJob.apply(this, arguments);
}
/**
 * updates the Job with signature attached by the CRMUser for better legibility
 * @method attachSignatureToJob
 * @name Jobin.Job.attachSignatureToJob
 * @param {string} jobId
 * @param {Array} files
 * @returns {Object} Success
 */
function _attachFilesToJob() {
  _attachFilesToJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(jobId, files) {
    var utilsFile, urls;
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          utilsFile = require("../utils/file");
          _context39.prev = 1;
          _context39.t0 = Parse.Cloud;
          _context39.t1 = jobId;
          _context39.next = 6;
          return utilsFile.filesParser(files);
        case 6:
          _context39.t2 = _context39.sent;
          _context39.t3 = sessionToken.getToken();
          _context39.t4 = {
            jobId: _context39.t1,
            files: _context39.t2,
            sessionToken: _context39.t3
          };
          _context39.next = 11;
          return _context39.t0.run.call(_context39.t0, "attachFilesToJob", _context39.t4);
        case 11:
          urls = _context39.sent;
          return _context39.abrupt("return", {
            status: "ok",
            result: urls
          });
        case 15:
          _context39.prev = 15;
          _context39.t5 = _context39["catch"](1);
          return _context39.abrupt("return", {
            status: "error",
            result: "error al adjuntar archivos al trabajo."
          });
        case 18:
        case "end":
          return _context39.stop();
      }
    }, _callee39, null, [[1, 15]]);
  }));
  return _attachFilesToJob.apply(this, arguments);
}
export function attachSignatureToJob(_x111, _x112) {
  return _attachSignatureToJob.apply(this, arguments);
}
/**
 * remove a single file from the Job
 * @method removeFileFromJob
 * @name Jobin.Job.removeFileFromJob
 * @param {string} jobId
 * @param {Array} files
 * @returns {Object} Success
 */
function _attachSignatureToJob() {
  _attachSignatureToJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(jobId, files) {
    var utilsFile, urls;
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          utilsFile = require("../utils/file");
          _context40.prev = 1;
          _context40.t0 = Parse.Cloud;
          _context40.t1 = jobId;
          _context40.next = 6;
          return utilsFile.filesParser(files);
        case 6:
          _context40.t2 = _context40.sent;
          _context40.t3 = sessionToken.getToken();
          _context40.t4 = {
            jobId: _context40.t1,
            files: _context40.t2,
            sessionToken: _context40.t3
          };
          _context40.next = 11;
          return _context40.t0.run.call(_context40.t0, "attachSignedNoteToJob", _context40.t4);
        case 11:
          urls = _context40.sent;
          return _context40.abrupt("return", {
            status: "ok",
            result: urls
          });
        case 15:
          _context40.prev = 15;
          _context40.t5 = _context40["catch"](1);
          console.error(_context40.t5);
          return _context40.abrupt("return", {
            status: "error",
            result: "Error al adjuntar los albaranes firmados al trabajo."
          });
        case 19:
        case "end":
          return _context40.stop();
      }
    }, _callee40, null, [[1, 15]]);
  }));
  return _attachSignatureToJob.apply(this, arguments);
}
export function removeFileFromJob(_x113, _x114) {
  return _removeFileFromJob.apply(this, arguments);
}
/**
 * Assigns a job to a agent (CRMUser)
 * @method reassignJob
 * @name Jobin.Job.reassignJob
 * @param {Parse.Object} job Job to assign
 * @param {Parse.Object} agent Agent (CRMUser) to assign the job to
 * @returns {boolean} Success
 */
function _removeFileFromJob() {
  _removeFileFromJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(jobId, filename) {
    var urls;
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          _context41.prev = 0;
          _context41.next = 3;
          return Parse.Cloud.run("removeFileFromJob", {
            jobId: jobId,
            filename: filename,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          urls = _context41.sent;
          return _context41.abrupt("return", {
            status: "ok",
            result: urls
          });
        case 7:
          _context41.prev = 7;
          _context41.t0 = _context41["catch"](0);
          return _context41.abrupt("return", {
            status: "error",
            result: "error al eliminar archivo del trabajo."
          });
        case 10:
        case "end":
          return _context41.stop();
      }
    }, _callee41, null, [[0, 7]]);
  }));
  return _removeFileFromJob.apply(this, arguments);
}
export function reassignJob(_x115, _x116) {
  return _reassignJob.apply(this, arguments);
}
function _reassignJob() {
  _reassignJob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(job, agent) {
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          _context42.prev = 0;
          _context42.next = 3;
          return Parse.Cloud.run("reassignJob", {
            jobId: job.id,
            assignedAgentId: agent.id,
            sessionToken: sessionToken.getToken()
          });
        case 3:
          return _context42.abrupt("return", {
            status: "ok",
            result: true
          });
        case 6:
          _context42.prev = 6;
          _context42.t0 = _context42["catch"](0);
          console.error(_context42.t0);
          return _context42.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de asignar el servicio."
          });
        case 10:
        case "end":
          return _context42.stop();
      }
    }, _callee42, null, [[0, 6]]);
  }));
  return _reassignJob.apply(this, arguments);
}